export const REGION = {
  SG: "SG",
  VN: "VN",
  KH: "KH",
  KR: "KR",
  ET: "ET",
  ID: "ID",
  HK: "HK",
  TH: "TH",
  CO: "CO",
  GLOBAL: "GLOBAL",
};

// SW: 왼쪽 아래 꼭짓점
// NE: 오른쪽 위 꼭짓점
export const COORD_BY_REGION = {
  [REGION.SG]: {
    SW: {
      lat: 1.1303609609603882,
      lon: 103.56666564941406,
    },
    NE: {
      lat: 1.478472113609314,
      lon: 104.12517547607422,
    },
  },
  [REGION.VN]: {
    SW: {
      lat: 9.775994300842285,
      lon: 105.2865982055664,
    },
    NE: {
      lat: 21.385221481323242,
      lon: 107.58256530761719,
    },
  },
  [REGION.KH]: {
    SW: {
      lat: 11.22593879699707,
      lon: 104.48118591308594,
    },
    NE: {
      lat: 11.85853099822998,
      lon: 105.09603881835938,
    },
  },
  [REGION.ET]: {
    SW: {
      lat: 5.753629,
      lon: 35.790888,
    },
    NE: {
      lat: 12.587961,
      lon: 41.889269,
    },
  },
  [REGION.HK]: {
    SW: { lat: 22.160074, lon: 113.824138 },
    NE: { lat: 22.578608, lon: 114.411405 },
  },
  [REGION.CO]: {
    SW: { lat: 37.036953, lon: -109.023113 },
    NE: { lat: 40.982037, lon: -102.074353 },
  },
};

export const LOCALE_BY_REGION = {
  [REGION.SG]: "en",
  [REGION.VN]: "vn",
  [REGION.KH]: "kh",
  [REGION.KR]: "ko",
  [REGION.ET]: "et",
  [REGION.ID]: "in",
  [REGION.HK]: "en",
  [REGION.TH]: "th",
  [REGION.CO]: "en",
  [REGION.GLOBAL]: "en",
};

export const AVAIL_TABLE = {
  easi6: ["en", "ko"],
  easi6_booking: ["en", "ko", "zh-CN", "zh-TW"],
  easi6_privacy: ["en", "ko"],
  easi6_rental: ["en", "ko"],
  easi6_platform_partner: ["en", "ko"],
  mvl_terms: ["en"],
  tada_privacy: ["en", "th"],
  tada_terms: ["en", "vn", "th"],
  tada_driver_codes: ["en", "kh", "th"],
  tada_driver_privacy: ["en", "kh", "th"],
  tada_driver_terms: ["en", "vn", "kh", "th"],
  wallet_terms: ["en", "kh"],
  mvltaxi_driver_terms: ["ko"],
  delivery_terms: ["en"],
  quiks_driver_terms: ["en", "in"],
  quiks_delivery_terms: ["en", "in"],
  quiks_privacy: ["en", "in"],
  community_guideline: ["en", "kh", "th"],
};

const POLICY_KEY = {
  MVL_TERMS: "mvl_terms",
  TADA_DRIVER_CODE_OF_CONDUCT: "tada_driver_codes",
  TADA_DRIVER_PRIVACY: "tada_driver_privacy",
  TADA_DRIVER_TERMS: "tada_driver_terms",
  TADA_RIDER_PRIVACY: "tada_privacy",
  TADA_RIDER_TERMS: "tada_terms",
  WALLET_TERMS: "wallet_terms",
  COMMUNITY_GUIDELINE: "community_guideline",
};

export const NONE_REGION_POLICY = [
  "delivery_terms",
  "easi6_booking",
  "easi6",
  "easi6_platform_partner",
  "easi6_privacy",
  "easi6_rental",
  "mvltaxi_driver_terms",
  "quiks_delivery_terms",
  "quiks_driver_terms",
  "quiks_privacy",
  "tada_delivery_terms",
];

export const AVAIL_TABLE_BY_REGION = {
  [REGION.SG]: {
    en: [
      POLICY_KEY.MVL_TERMS,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    vn: [],
    kh: [],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [],
    jp: [],
  },
  [REGION.VN]: {
    en: [POLICY_KEY.TADA_DRIVER_TERMS],
    vn: [
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_TERMS,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
    ],
    kh: [],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [],
    jp: [],
  },
  [REGION.KH]: {
    en: [
      POLICY_KEY.WALLET_TERMS,
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    vn: [],
    kh: [
      POLICY_KEY.WALLET_TERMS,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [],
    jp: [],
  },
  [REGION.TH]: {
    en: [
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    vn: [],
    kh: [],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    jp: [],
  },
  [REGION.HK]: {
    en: [
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    vn: [],
    kh: [],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [],
    jp: [],
  },
  [REGION.CO]: {
    en: [
      POLICY_KEY.COMMUNITY_GUIDELINE,
      POLICY_KEY.TADA_DRIVER_CODE_OF_CONDUCT,
      POLICY_KEY.TADA_DRIVER_PRIVACY,
      POLICY_KEY.TADA_RIDER_PRIVACY,
      POLICY_KEY.TADA_DRIVER_TERMS,
      POLICY_KEY.TADA_RIDER_TERMS,
    ],
    vn: [],
    kh: [],
    ko: [],
    "zh-CN": [],
    "zh-TW": [],
    et: [],
    in: [],
    th: [],
    jp: [],
  },
};

export const NONE_SG_POLICIES = ["wallet_terms"];

export const AVAILABLE_REGION = [
  REGION.SG,
  REGION.KH,
  REGION.VN,
  REGION.TH,
  REGION.HK,
  REGION.CO,
];

export const LOCALE_TYPE = {
  EN: "en",
  KO: "ko",
  KH: "kh",
  VN: "vn",
  TH: "th",
  ZH_CN: "zh-CN",
  zh_TW: "zh-TW",
  jp: "jp",
};

export const REGION_BY_LOCALE = {
  [LOCALE_TYPE.EN]: [REGION.SG, REGION.HK, REGION.CO],
  [LOCALE_TYPE.VN]: [REGION.VN],
  [LOCALE_TYPE.KH]: [REGION.KH],
  [LOCALE_TYPE.KO]: [REGION.KR],
  [LOCALE_TYPE.TH]: [REGION.TH],
  [LOCALE_TYPE.zh_TW]: [REGION.HK],
};



// WEBPACK FOOTER //
// ./src/assets/constants.js